import { createContext } from 'react';
import type {
  FrontendAccessPolicy,
  LoginCredentials,
  PlatformEntryContext,
  RegistrationPayload,
  User,
} from '@/types';

export interface AuthContextType {
  user: User | null;
  accessPolicy: FrontendAccessPolicy | null;
  entryContext: PlatformEntryContext | null;
  loading: boolean;
  login: (credentials: LoginCredentials) => Promise<void>;
  register: (payload: RegistrationPayload) => Promise<void>;
  logout: () => void;
  refreshEntryContext: () => Promise<PlatformEntryContext | null>;
  isAuthenticated: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
